import { themed } from "@tamagui/helpers-icon";
import { memo } from "react";
import { Svg, Path } from "react-native-svg";

import type { IconProps } from "@tamagui/helpers-icon";
import type { NamedExoticComponent } from "react";

const Icon = (props) => {
  const { color = "black", size = 32, ...otherProps } = props;
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      {...otherProps}
    >
      <Path
        d="M5.66659 19.4408C4.19718 20.2573 3.33325 21.2555 3.33325 22.3333C3.33325 25.0947 9.00431 27.3333 15.9999 27.3333C22.9955 27.3333 28.6666 25.0947 28.6666 22.3333C28.6666 21.2555 27.8027 20.2573 26.3333 19.4408M15.9999 22C17.768 22 19.4637 21.2754 20.714 19.9857C21.9642 18.696 22.6666 16.9467 22.6666 15.1228C22.6666 13.1579 21.7142 11.2912 19.8094 9.71929C17.9047 8.14736 16.4761 5.78947 15.9999 3.33333C15.5237 5.78947 14.0952 8.14736 12.1904 9.71929C10.2856 11.2912 9.33325 13.1579 9.33325 15.1228C9.33325 16.9467 10.0356 18.696 11.2859 19.9857C12.5361 21.2754 14.2318 22 15.9999 22Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

Icon.displayName = "WaterLeak";

export const WaterLeak: NamedExoticComponent<IconProps> = memo<IconProps>(
  themed(Icon),
);
